import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useChatStore } from './chatStore';

export function MessageList() {
  const { t } = useTranslation('chat');
  const messages = useChatStore((s) => s.messages);
  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  if (messages.length === 0) {
    return (
      <div className="flex h-full items-center justify-center p-4 text-center text-xs text-muted-foreground">
        {t('emptyState')}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-3">
      {messages.map((msg) => {
        const isUser = msg.role === 'user';
        return (
          <div
            key={msg.id}
            className={`flex flex-col gap-1 ${isUser ? 'items-end' : 'items-start'}`}
          >
            <span className="text-[10px] uppercase text-muted-foreground">
              {isUser ? t('you') : t('agent')}
            </span>
            <div
              className={`max-w-[85%] whitespace-pre-wrap rounded-lg px-3 py-2 text-sm ${
                isUser
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-foreground'
              }`}
            >
              {msg.content}
            </div>
            {msg.uiAction && (
              <span
                className="rounded-full border border-border bg-card px-2 py-0.5 text-[10px] text-muted-foreground"
                role="status"
              >
                {t('openedSurface', { title: msg.uiAction.title })}
              </span>
            )}
          </div>
        );
      })}
      <div ref={endRef} />
    </div>
  );
}
